import { Component, OnInit } from '@angular/core';
import { PaymentService } from '@core/payments/services/payment.service';
import { LoaderService } from '@shared/services/loader.service';
import { ThemeService } from '@shared/services/theme.service';
import { SignJWT } from 'jose';
import { LabelService } from '@core/payments/services/label.service';

@Component({
    selector: 'app-confirmationpayment',
    templateUrl: './confirmationpayment.component.html',
    styleUrls: ['./confirmationpayment.component.css'],
    standalone: false
})
export class ConfirmationpaymentComponent implements OnInit {
  public titlepayment: string = 'Pago Rechazado!';
  public estatuspayment: string = 'RECHAZADA';
  public tipo_compra: string = 'RECARGA';
  public aprobedpayment: boolean = false;
  public currintpayment: string = '0';
  public numberauth: string = '0';
  public approvalCode: string = '0';
  public datepayment: string = '';
  public fechatrans: string = '';
  public horatrans: string = '';
  public isDam: boolean = false;
  public isDamtrans: boolean = true;
  public phoneNumber: string | null = '';
  public rejectReason: string = '';
  public isNationalCard: boolean = false;
  public isErrorDomiciliation: boolean = false;
  public MessageDomiciliation: String = '';
  public isDarkMode: boolean = false;
  public currencySymbol:string= ''
  public channel: number = 0;
  public menssageApproved: string = '';
  public currentLanguage: 'es' | 'en' = 'es';
  public menssageApproved1: string = '';
  public arraylabels: any = {};
  constructor(
    private _paymentService: PaymentService,
    private _loaderService: LoaderService,
    private themeService: ThemeService,
    private LabelService: LabelService,

  ) {
    this.isDarkMode = this.themeService.isDarkMode();
  }

  ngOnInit(): void {
    this.enviocorreo();
  }

  async enviocorreo(): Promise<void> {
    try {
      this.phoneNumber = localStorage.getItem('phoneNumber');
      this.channel = Number(localStorage.getItem('channel'));
      this.arraylabels = localStorage.getItem('paymentScreenData');
      this.arraylabels = JSON.parse(this.arraylabels);
      this.currencySymbol = localStorage.getItem('currencySymbol') as string;
      this.currintpayment =
        this._paymentService.requestpayment.result.totalAmount;

      if (this._paymentService.requestpayment.result.status === 'APPROVED') {
        this.titlepayment = 'Gracias por tu pago!';
        this.estatuspayment = 'APROBADO';
        this.aprobedpayment = true;
      } else if (
        this._paymentService.requestpayment.result.status === 'EXPIRED'
      ) {
        this.titlepayment = 'Transacción Expirada!';
        this.estatuspayment = 'EXPIRADA';
        this.aprobedpayment = false;
      }

      if (this._paymentService.afilcard) {
        const result = this._paymentService.requestpayment?.result;

        if (result?.status === 'DECLINED') {
          this.isDam = false;
          return;
        }

        if ('EnrollAutomaticPaymentResult' in result) {
          const enrollResult = result.EnrollAutomaticPaymentResult;

          if (enrollResult.resultCode === 'ERROR') {
            this.isDam = false;
            this.isErrorDomiciliation = true;

            console.log(enrollResult.resultMessage); //todo: borrar en el futuro cercano

            this.MessageDomiciliation =
              'Error en el proceso de Domiciliación: ¡Lo sentimos!, la domiciliación no pudo ser creada, por favor intentalo nuevamente mas tarde.';
          } else {
            this.isDam = result.isNational;
            this.isNationalCard = !result.isNational;
          }
        } else {
          this.isDam = result.isNational;
          this.isNationalCard = !result.isNational;
        }
      }

      this.currintpayment =
        this._paymentService.requestpayment.result.totalAmount;
      this.numberauth = this._paymentService.requestpayment.result.cus;
      this.approvalCode =
        this._paymentService.requestpayment.result.approvalCode;
      this.datepayment = this._paymentService.requestpayment.result.dateFormat
        .split('a las ')
        .join('');
      this.fechatrans =
        this._paymentService.requestpayment.result.dateFormat.split(
          'a las '
        )[0];
      this.horatrans =
        this._paymentService.requestpayment.result.dateFormat.split(
          'a las '
        )[1];
      if (localStorage.getItem('tipo_seleccion') === 'P')
        this.tipo_compra = 'PAQUETE';

      const secretKey = new TextEncoder().encode(
        localStorage.getItem('clnum') as string
      );

      const payload = {
        channel: Number(localStorage.getItem('channel')),
        estatuspayment: this.estatuspayment,
        phoneNumber: this.phoneNumber,
        tipo_compra: this.tipo_compra,
        fechatrans: this.fechatrans,
        horatrans: this.horatrans,
        referencia: this._paymentService.requestpayment.result.cus,
        codigo: this._paymentService.requestpayment.result.approvalCode,
        numbercard:
          this._paymentService.requestpayment.result.paymentMethod.split(
            '************'
          )[1],
        amount: this._paymentService.requestpayment.result.totalAmount,
        factura: localStorage.getItem('numerofactura'),
        asunto: 'Comprobante de la transacción',
        correo: this._paymentService.email,
        clnum: localStorage.getItem('clnum'),
      };
      this.processPayment(payload, secretKey);
    } catch (error) {
      console.error('There was an error!', error);
    }
  }

  async processPayment(payload: any, secretKey: any) {
    try {
      const jwt = await new SignJWT(payload)
        .setProtectedHeader({ alg: 'HS256' })
        .setExpirationTime('1h')
        .sign(secretKey);
      const hash1 = await this._paymentService.hashSHA256('c3n4ms3rv1c3');
      const hash2 = await this._paymentService.hashSHA256(
        'cmViUUFLQ0NuQkNUb1BLQXU3d3FNMUFhcENMMnVzWE46Rm5XcjFUendETDNwUmQwZQ==' +
          hash1
      );
      const auth =  this._paymentService.getAuthToken();
      const result = await this._paymentService.sendEmailConfirmationPayment(
        hash2,
        jwt,
        auth
      );
      console.log('Respuesta exitosa:', result);
      this._loaderService.hideLoading();
    } catch (error) {
      this._loaderService.hideLoading();
    }
  }


  // Método para obtener las etiquetas según la clave, idioma y canal actuales
  // Si se envia el canal como 7 se obtienen las etiquetas en español e ingles
  getLabel(key: string): string {
    // Llama al servicio para obtener los textos
    return this.LabelService.getLabel(key, this.currentLanguage, this.channel);
  }
}
